import "./helvetica.css2.js";
const a = "https://static.parastorage.com/services/fonts-data/dist/helvetica.om9dqyoql9acvmv2duol.css";
export {
  a as default
};
//# sourceMappingURL=helvetica.css.js.map
